import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '@Auth/components/LoadingSpinner';
import { useUserStore } from '@Auth/store';
import { authProvider } from '@helpers/auth/authProvider';
import { useListingPagesStore } from '@pages/User/store/listingPages.store';
import { useEffectOnce } from '@src/hooks';
import Nav from '@src/routes';
import { queryClient } from '@utils/queryClient';

export const CognitoLogout = () => {
  const navigate = useNavigate();

  const signOut = async () => {
    try {
      useUserStore.getState().clearUser();
      useListingPagesStore.getState().clearSessionState();
      await authProvider.logout();
    } catch {
      // Provider sign-out failure must not block local logout — state is already cleared
    } finally {
      // Per-user server state (e.g. saved views) must not leak into the next login in this tab.
      queryClient.clear();
      navigate(Nav.Login);
    }
  };

  useEffectOnce(() => {
    signOut();
  });

  return <LoadingSpinner />;
};
